import React from 'react';

import { projectOne, projectTwo, projectThree } from '../../assets/index';
import projectfour from '../../assets/images/projects/retour_landing.png';
import projectThreee from '../../assets/images/projects/projectThreee.jpeg';
import ProjectsCard from './ProjectsCard';

const Projects = () => {
  return (
    <section id="projects" className="w-full py-20 border-b-[1px] border-b-gray-800">
      <div className="flex justify-center items-center text-center">
        <div className="flex flex-col gap-4 font-titleFont mb-14">
          <h3 className="text-sm uppercase font-light text-designColor tracking-wider">
            Innovation & Performance
          </h3>
          <h1 className="text-4xl md:text-5xl font-bold capitalize text-gray-300">
            Featured Projects
          </h1>
          <p className="text-sm md:text-base font-bodyFont text-gray-500 tracking-wide mt-2">
            A selection of technical projects and products focusing on real-world impact.
          </p>
        </div>
      </div>
      <div className="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-3 gap-6 xl:gap-14">
        <ProjectsCard
          title="Retour"
          des="Retour is a real-time feedback collection platform for modern teams that captures user responses instantly, analyzes sentiment with AI, and delivers actionable insights through a clean dashboard—with seamless Slack integration to notify your team the moment feedback arrives."
          src={projectfour}
          projectLink="https://www.retour.tech/"
        />
        <ProjectsCard
          title="Revenantpulse"
          des="RevenantPulse provides real-time notifications for your SaaS, delivering instant updates to your Discord for critical events like sales, new user signups, and payments. Track custom events and properties."
          src={projectThreee}
          projectLink="https://revenantpulse.vercel.app/"
        />
        <ProjectsCard
          title="WipeBoard"
          des="WipeBoard is a digital tool for instantly clearing text and drawings, offering a clean workspace for teams. It enhances productivity and collaboration."
          src={projectThree}
          projectLink="https://wipe-board.vercel.app/"
        />
        <ProjectsCard
          title="MeetMate"
          des="MeetMate is a secure video conferencing platform with HD video, screen sharing, and chat, perfect for remote work and virtual events."
          src={projectOne}
          projectLink="https://meet-mate-eta.vercel.app"
        />
        <ProjectsCard
          title="Loop"
          des="Loop: A collaborative workspace app for real-time document sharing and editing, featuring modular components, cross-platform access, and role-based security."
          src={projectTwo}
          projectLink="https://loop-beta-six.vercel.app/"
        />
      </div>
    </section>
  );
};

export default Projects;
